"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateHTML = exports.objToCSS = exports.cqlLogicClauseFalseStyle = exports.cqlLogicClauseTrueStyle = void 0;
var handlebars_1 = __importDefault(require("handlebars"));
var Enums_1 = require("../types/Enums");
var main_1 = __importDefault(require("../templates/main"));
var clause_1 = __importDefault(require("../templates/clause"));
var CustomErrors_1 = require("../types/errors/CustomErrors");
exports.cqlLogicClauseTrueStyle = {
    'background-color': '#ccebe0',
    color: '#20744c',
    'border-bottom-color': '#20744c',
    'border-bottom-style': 'solid'
};
exports.cqlLogicClauseFalseStyle = {
    'background-color': '#edd8d0',
    color: '#a63b12',
    'border-bottom-color': '#a63b12',
    'border-bottom-style': 'double'
};
/**
 * Convert JS object to CSS Style string
 *
 * @param obj JS object representing CSS styles
 * @returns semi-colon separated string of CSS styles for style attribute
 */
function objToCSS(obj) {
    return Object.entries(obj)
        .map(function (_a) {
        var k = _a[0], v = _a[1];
        return k + ":" + v;
    })
        .join(';');
}
exports.objToCSS = objToCSS;
var main = handlebars_1.default.compile(main_1.default);
handlebars_1.default.registerPartial('clause', clause_1.default);
// text values in annotations show up as an array of strings
handlebars_1.default.registerHelper('concat', function (s) { return s.join(''); });
// apply highlighting style based on clause result
handlebars_1.default.registerHelper('highlightClause', function (localId, context) {
    var libraryName = context.data.root.libraryName;
    var clauseResults = context.data.root.clauseResults;
    var clauseResult = clauseResults.find(function (result) { return result.libraryName === libraryName && result.localId === localId; });
    if (clauseResult) {
        if (clauseResult.final === Enums_1.FinalResult.TRUE) {
            return objToCSS(exports.cqlLogicClauseTrueStyle);
        }
        else if (clauseResult.final === Enums_1.FinalResult.FALSE) {
            return objToCSS(exports.cqlLogicClauseFalseStyle);
        }
    }
    return '';
});
/**
 * Generate HTML structure based on ELM annotations in relevant statements
 *
 * @param elmLibraries main ELM and dependencies to lookup statements
 * @param statementResults StatementResult array from calculation
 * @param groupId ID of population group
 * @returns string of HTML representing the clauses for this group
 */
function generateHTML(elmLibraries, statementResults, clauseResults, groupId) {
    var relevantStatements = statementResults.filter(function (s) { return s.relevance === Enums_1.Relevance.TRUE; });
    // assemble array of statement annotations to be templated to HTML
    var statementAnnotations = [];
    relevantStatements.forEach(function (s) {
        var matchingLibrary = elmLibraries.find(function (e) { return e.library.identifier.id === s.libraryName; });
        if (!matchingLibrary) {
            throw new CustomErrors_1.UnexpectedResource("Could not find library " + s.libraryName + " for statement " + s.statementName);
        }
        var matchingExpression = matchingLibrary.library.statements.def.find(function (e) { return e.name === s.statementName; });
        if (!matchingExpression) {
            throw new CustomErrors_1.UnexpectedProperty("No statement " + s.statementName + " found in library " + s.libraryName);
        }
        if (matchingExpression.annotation) {
            statementAnnotations.push({
                libraryName: s.libraryName,
                annotation: matchingExpression.annotation
            });
        }
    });
    var result = "<div><h2>Population Group: " + groupId + "</h2>";
    // generate HTML clauses using hbs template for each annotation
    statementAnnotations.forEach(function (a) {
        var res = main(__assign({ libraryName: a.libraryName, clauseResults: clauseResults }, a.annotation[0].s));
        result += res;
    });
    result += '</div>';
    return result;
}
exports.generateHTML = generateHTML;
//# sourceMappingURL=HTMLBuilder.js.map